import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VendorUser } from '../helpers/InterfacesServer';

interface VendorUsersState {
  value: Map<string, VendorUser>
}

export const vendorUsersDict = createSlice({
  name: 'vendorUsersDict',
  initialState: {
    value: new Map<string, VendorUser>(),
  } as VendorUsersState,
  reducers: {
    setVendorUsersDict: (state, action: PayloadAction<Map<string, VendorUser>>) => {
      state.value = action.payload
    },
  },
})

export const { setVendorUsersDict } = vendorUsersDict.actions;
export default vendorUsersDict.reducer;